interface Settings {
  nomeCliente: string;
  endPoint: string;
}

export function getSettings(): Settings {
  return {
    nomeCliente: 'ALEPI',
    endPoint: 'https://lgpdalepi-portaltitularw.azurewebsites.net/api/',
  };
};
